import { Shadows } from '@zapier/design-system';
export const imgConfig = {
    name: 'Img',
    category: 'Zapier Blocks',
    image: 'https://cdn.zappy.app/b39b3768fca22ab65885f9c661c2eb0a.png',
    inputs: [
        {
            name: 'src',
            type: 'cloudinaryMediaLibrary',
            required: true,
        },
        {
            name: 'alt',
            type: 'string',
        },
        {
            name: 'isFullWidth',
            type: 'boolean',
            defaultValue: true,
        },
        {
            name: 'width',
            type: 'number',
        },
        {
            name: 'height',
            type: 'number',
        },
        {
            name: 'borderRadius',
            type: 'number',
        },
        {
            name: 'loading',
            type: 'string',
            enum: ['eager', 'lazy'],
        },
        {
            name: 'objectFit',
            type: 'string',
            enum: ['contain', 'cover', 'fill', 'none', 'scale-down'],
        },
        {
            name: 'objectPosition',
            type: 'string',
        },
        {
            name: 'aspectRatio',
            type: 'string',
        },
        {
            name: 'shadow',
            type: 'string',
            enum: Object.keys(Shadows),
        },
        {
            name: 'sizes',
            type: 'string',
        },
        {
            name: 'ariaHidden',
            type: 'boolean',
        },
    ],
};
//# sourceMappingURL=config.js.map